export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_REQUESTED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_SUCCEEDED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_SUCCEEDED';
export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_FAILED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_FAILED';

export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_REQUESTED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_SUCCEEDED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_FAILED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_CANCELED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_CANCELED';

export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_REQUESTED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_SUCCEEDED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_SUCCEEDED';
export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_FAILED =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_FAILED';

export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_SET =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_SET';
export const REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_MERGE =
    'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_MERGE';
export const REPORTS_HARVEST_INSPECTION_SET = 'REPORTS_HARVEST_INSPECTION_SET';
